<div class="cerrix-select">
    @if (data) {
        <div>
            @if (showNoData) {
                <label class="no-data"
                    >{{ "noDataAvailable" | t: { prettyName: prettyName } }}
                    @if (showRefreshButton) {
                        <i
                            [title]="'reloadTitle' | t"
                            class="fas fa-sync me-2"
                            (click)="reloadData()"
                        ></i>
                    }
                </label>
            }
            @if (data.length > 0) {
                <ng-select
                    [id]="id"
                    [items]="data"
                    [bindLabel]="bindLabel"
                    [bindValue]="bindValue"
                    [closeOnSelect]="closeOnSelect"
                    [placeholder]="placeholder"
                    [multiple]="multiple"
                    [(ngModel)]="value"
                    [ngModelOptions]="ngModelOptions"
                    [disabled]="disabled"
                    [addTag]="addTag"
                    [searchable]="searchable"
                    [clearable]="clearable"
                    [attr.data-uiid]="dataUiid"
                >
                    @if (data[0][bindColor]) {
                        <ng-template ng-label-tmp ng-option-tmp let-item="item">
                            <div
                                [style.background-color]="item[bindColor]"
                                class="cerrix-select-color-element"
                                style="
                                    min-width: 5px;
                                    min-height: 16px;
                                    float: left;
                                    margin-right: 10px;
                                "
                            ></div>
                            {{ item[bindLabel] }}
                        </ng-template>
                    }
                </ng-select>
            }
        </div>
    } @else {
        <div>
            <i class="fas fa-circle-notch fa-spin me-2" data-uiid="data-loader"></i>
        </div>
    }
</div>
